import React from 'react';
import Icon from '../../ui/icon/icon';
import RateCard from '../rateCard/rateCard';
import RateSubGroupCard from '../rateSubGroupCard/rateSubGroupCard';
import { classnames } from '../../../../utils/classnames';
import './rateGroupCard.css';

export default function RateGroupCard({group, mode, event, selectedRates, setSelectedRates, max_ticket, disable_plus, disable_minus, expand_rate_groups, currency}) {
    const [showMore, setShowMore] = React.useState(expand_rate_groups === '0' ? false : true);
    const toggleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

    const sortWithDisplayOrder = (a, b) => Object.keys(a).includes('display_order') &&
        Object.keys(b).includes('display_order') ? a['display_order'] - b['display_order'] :
        Object.keys(b).includes('display_order') ? -1 : 1;

    const rates = React.useMemo(() => group.rates.sort(sortWithDisplayOrder), [group.rates]);
    const subGroups = React.useMemo(() => group.children.sort(sortWithDisplayOrder), [group.children]);

    return (
        <>
            <h3>
                <button type='button' id={`group_${group.id}`} aria-expanded={String(showMore)} aria-controls={`group_${group.id}_section`} className='neo-rate-group-card__trigger' onClick={toggleShowMore}>
                    <div className='neo-rate-group-card__trigger-content'>
                        <div className='neo-rate-group-left'>
                            <p className='neo-rate-group-title'>{group.name}</p>
                        </div>
                        <div className='neo-rate-group-right'>
                            <div className='neo-rate-group-icon-container'>
                                <Icon name='arrow' size='small' className={`neo-rate-group-icon ${showMore ? 'neo-rate-group-icon-down' : 'neo-rate-group-icon-up'}`} />
                            </div>
                        </div>
                    </div>
                </button>
            </h3>
            <div 
                role="region" 
                id={`group_${group.id}_section`} 
                aria-labelledby={`group_${group.id}`}
                className={classnames('neo-attendee-rate-group-children', {'display-block': showMore})}
            >
                {rates.map(rate => (
                    <RateCard key={rate.id} mode={mode} rate={rate} event={event} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={disable_plus} disable_minus={disable_minus} max_ticket={max_ticket} currency={currency}/>
                ))}
                {subGroups.map(gr => (
                    <RateSubGroupCard key={gr.id} mode={mode} className='neo-subgroup' group={gr} event={event} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={disable_plus} disable_minus={disable_minus} max_ticket={max_ticket} expand_rate_groups={expand_rate_groups} currency={currency}/>
                ))}
            </div>
        </>
    )
}